import { Shield, Zap, Lightbulb } from 'lucide-react'
import { BottomSheet } from './ui'
import { haptics } from '../lib/haptics'

interface Props {
  open: boolean
  onClose: () => void
  onTryPrivateChat?: () => void
}

const COCOON_PURPLE = '#A062FF'

function Section({
  icon,
  title,
  body,
}: {
  icon: React.ReactNode
  title: string
  body: string
}) {
  return (
    <div className="flex gap-sp-3">
      <div className="shrink-0 mt-0.5">{icon}</div>
      <div>
        <p className="text-[15px] font-semibold" style={{ color: 'var(--tg-theme-text-color)' }}>
          {title}
        </p>
        <p className="text-[13px] mt-1 leading-relaxed" style={{ color: 'var(--tg-theme-hint-color)' }}>
          {body}
        </p>
      </div>
    </div>
  )
}

export default function PrivacyInfoSheet({ open, onClose, onTryPrivateChat }: Props) {
  return (
    <BottomSheet open={open} onClose={onClose} title="Private Inference" maxHeight="70vh">
      <div className="px-sp-4 pb-sp-6 flex flex-col gap-sp-5">
        <Section
          icon={<Shield size={20} color={COCOON_PURPLE} />}
          title="What it means"
          body="Your prompts are encrypted inside Intel TDX hardware. Not even IMAGO can read them — zero-knowledge by design."
        />

        <Section
          icon={<Zap size={20} color={COCOON_PURPLE} />}
          title="How it's different"
          body="Standard API: server processes your prompts in plaintext. TEE: hardware-isolated enclave with cryptographic attestation. No logs, no leaks."
        />

        <Section
          icon={<Lightbulb size={20} color={COCOON_PURPLE} />}
          title="When to use"
          body="Personal data, business secrets, confidential strategies, sensitive conversations — anything you wouldn't want on a server."
        />

        {onTryPrivateChat && (
          <button
            onClick={() => {
              haptics.impact('medium')
              onTryPrivateChat()
            }}
            className="w-full h-14 rounded-[14px] text-[17px] font-semibold active:opacity-70 transition-opacity"
            style={{
              background: 'linear-gradient(110deg, #A062FF 0%, #3088FF 30%, #61D8FF 60%, #A062FF 85%, #3088FF 100%)',
              backgroundSize: '200% 100%',
              animation: 'cocoon-flow 3s ease-in-out infinite',
              color: '#ffffff',
            }}
          >
            Try Private Chat
          </button>
        )}

        <p className="text-[11px] text-center" style={{ color: 'var(--tg-theme-hint-color)' }}>
          Powered by{' '}
          <a
            href="https://cocoon.ai"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            Cocoon TEE
          </a>
        </p>
      </div>
    </BottomSheet>
  )
}
